/* eslint-disable ta-code-conventions/has-matching-storydoc */
// @flow

import * as React from 'react';
import { Mutation, type MutationResult } from 'react-apollo';
import BlockStatusQuery from './BlockStatusQuery.gql';
import UnblockProfileMutation from './UnblockProfile.gql';

type Props = {|
  userIdToUnblock: string,
  // $FlowFixGraphql
  children: (unblockProfile: () => Promise<*>, result: MutationResult) => React.Node,
|};

/** Thin wrapper around a Mutation component for re-use. Not interesting enough to have a story */

const UnblockProfile = ({ userIdToUnblock, children }: Props) => (
  <Mutation
    mutation={UnblockProfileMutation}
    refetchQueries={[{ query: BlockStatusQuery, variables: { userId: userIdToUnblock } }]}
    awaitRefetchQueries
  >
    {(mutate, result) => children(() => mutate({ variables: { userIdToUnblock } }), result)}
  </Mutation>
);

export default UnblockProfile;
